export default __webpack_public_path__ + "static/media/KOD0059-min.297e2af8.webp";